// src/utils/storage.js
const SITES_KEY = 'nieuwVennepZuid_sites';

export const loadSites = () => {
  try {
    const serializedSites = localStorage.getItem(SITES_KEY);
    if (serializedSites === null) {
      return []; // No sites stored yet, return empty or initial demo data
    }
    const sites = JSON.parse(serializedSites);
    // Convert date strings back to Date objects if necessary (especially for CSV data)
    return sites.map(site => ({
      ...site,
      csvData: site.csvData.map(csv => ({
        ...csv,
        data: csv.data.map(row => ({
          ...row,
          datetime: new Date(row.datetime) // Ensure datetime is a Date object
        }))
      }))
    }));
  } catch (error) {
    console.error("Could not load sites from localStorage", error);
    return [];
  }
};

export const saveSites = (sites) => {
  try {
    const serializedSites = JSON.stringify(sites);
    localStorage.setItem(SITES_KEY, serializedSites);
  } catch (error) {
    console.error("Could not save sites to localStorage", error);
  }
};